var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfotech(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.637,
    height: 20.516,
    viewBox: "0 0 30.637 20.516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2346",
    "data-name": "Group 2346",
    transform: "translate(-322.25 -393.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book",
    transform: "translate(321.125 390.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M9.5,4.545a16.6,16.6,0,0,0-6.94-1.17,1.411,1.411,0,0,0-.806.24,1.44,1.44,0,0,0-.633,1.2V17.682a1.453,1.453,0,0,0,1.44,1.527c3.2,0,6.405.3,8.326,2.115a.185.185,0,0,0,.312-.135V6.022a.715.715,0,0,0-.246-.54A6.434,6.434,0,0,0,9.5,4.545Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M28.57,3.614a1.41,1.41,0,0,0-.806-.239,16.571,16.571,0,0,0-6.94,1.17,6.448,6.448,0,0,0-1.454.935.717.717,0,0,0-.245.54V21.188a.177.177,0,0,0,.3.127c1.155-1.147,3.182-2.107,8.34-2.106a1.44,1.44,0,0,0,1.44-1.44V4.811a1.44,1.44,0,0,0-.635-1.2Z",
    transform: "translate(-6.482)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M6.16,17.836.265,11.942a.907.907,0,0,1,0-1.283L1.548,9.377a.907.907,0,0,1,1.283,0L6.8,13.347l8.505-8.505a.907.907,0,0,1,1.283,0l1.283,1.283a.907.907,0,0,1,0,1.283L7.443,17.836a.907.907,0,0,1-1.283,0Z",
    transform: "translate(334.75 395.898)",
    fill: "#00c742"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfotech);
export default __webpack_public_path__ + "static/media/infotech.374cc3fb7803e118f7534a5cee610287.svg";
export { ForwardRef as ReactComponent };